document.addEventListener('DOMContentLoaded', () => {
  const button = document.getElementById('floating-menu-button');
  const menu = document.getElementById('floating-menu');
  const overlay = document.getElementById('floating-menu-overlay');
  const closeButton = document.getElementById('floating-menu-close');

  const openMenu = () => {
    if (!menu || !overlay) return;
    menu.classList.add('is-open');
    overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  };

  const closeMenu = () => {
    if (!menu || !overlay) return;
    menu.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  };

  const toggleSubmenu = (toggle) => {
    const submenuId = toggle.getAttribute('data-submenu-id');
    const submenu = document.getElementById(submenuId);
    if (!submenu) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', !isExpanded);
    submenu.classList.toggle('is-open');
  };

  if (button) {
    button.addEventListener('click', openMenu);
  }

  if (closeButton) {
    closeButton.addEventListener('click', closeMenu);
  }

  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }

  document.querySelectorAll('.floating-menu__submenu-toggle').forEach(toggle => {
    toggle.addEventListener('click', () => toggleSubmenu(toggle));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.classList.contains('is-open')) {
      closeMenu();
    }
  });
});
